/**
 * WeakRef and FinalizationRegistry are not available in all environments.
 * https://caniuse.com/?search=weakref
 */
export const IS_WEAK_HASHING_SUPPORTED =
    typeof WeakRef !== 'undefined' && typeof FinalizationRegistry !== 'undefined';
